import {
  IPlacesApiAdapter,
  PlaceDetails,
  PlacesApiAdditionalOptions,
  PlaceSuggestion,
} from '../types';

export class StoreAddonsNeighborhoodDecorator implements IPlacesApiAdapter {
  private readonly api: IPlacesApiAdapter;

  constructor(placesApi: IPlacesApiAdapter) {
    this.api = placesApi;
  }

  async suggestPlaces(input: string): Promise<PlaceSuggestion[]> {
    return this.api.suggestPlaces(input);
  }

  async searchPlaces(input: string, options?: PlacesApiAdditionalOptions): Promise<PlaceDetails[]> {
    return this.api.searchPlaces(input, options);
  }

  async getPlaceDetails(
    placeId: string,
    options?: PlacesApiAdditionalOptions,
  ): Promise<PlaceDetails> {
    return this.api.getPlaceDetails(placeId, options);
  }
}
